import __request__ from 'routing/request';
interface SalesforceRequestImpl {
    readonly salesforce_client_secret: string;
    readonly salesforce_client_id: string;
    readonly salesforce_base_url: string;
}
interface SalesforceCreateInputRequest {
    readonly salesforce_client_secret: string;
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly log_types: string[];
    readonly salesforce_client_id: string;
    readonly name: string;
    readonly access_token_expiry_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly salesforce_base_url: string;
    readonly enable_throttling: boolean;
    readonly polling_interval: number;
    readonly access_token_expires_in: number;
}
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
/**
 * Validate input credentials
 */
export function checkCredentials(JSONbody: SalesforceRequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.salesforce.api.SalesforceResource/salesforce/checkCredentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Validate input credentials
 */
export function getLogTypes(): Promise<MediaType> {
    return __request__('GET', '/plugins/org.graylog.enterprise.integrations.salesforce.api.SalesforceResource/salesforce/getLogTypes', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new Salesforce input
 */
export function create(JSONbody: SalesforceCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.salesforce.api.SalesforceResource/salesforce/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
